import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext'


const LogoDisplay = () => {
  const navigate = useNavigate();
const { user } = useAuth();

  return (
    <Box
      sx={{
        mr: 2,
        ml: 2,
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        '&:hover': {
          opacity: 0.8,
          transition: 'opacity 0.2s ease-in-out'
        }
      }}
      onClick={() => { user != null ? navigate('/dashboard') : navigate('/'); }}
    >
      <img src={`${process.env.PUBLIC_URL}/assets/uniofunds_noBgWhite.png`} alt="UnioFunds Logo" height={24} />
    </Box>
  );
};

export default LogoDisplay;